import React from 'react';
import { captureError } from '../utils/analytics.js';

interface State { hasError: boolean; error: Error | null }

export default class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    captureError(error, `react:${info.componentStack?.slice(0, 500)}`);
    import('../utils/sentry').then(({ captureException }) => {
      captureException(error, {
        componentStack: info.componentStack,
        boundary: 'react-error-boundary',
      });
    });
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        minHeight: '100vh', padding: 32, fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        background: 'var(--color-bg, #f8f9fa)', color: 'var(--color-text, #1a1a1a)',
      }}>
        <div style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>Something went wrong</div>
        <div style={{ fontSize: 14, color: 'var(--color-text-2, #666)', marginBottom: 20, textAlign: 'center', maxWidth: 400 }}>
          An unexpected error occurred. Your data is safe — reload to continue.
        </div>
        <button
          onClick={() => window.location.reload()}
          style={{
            padding: '10px 24px', fontSize: 14, fontWeight: 600,
            background: 'var(--color-primary, #2563eb)', color: '#fff',
            border: 'none', borderRadius: 6, cursor: 'pointer',
          }}
        >
          Reload page
        </button>
      </div>
    );
  }
}
